<template>
<modal title="Add Testing Environment">
  <form>
    <div class="columns">
      <div class="column">
        <text-input 
          required 
          :error="$root.errorBag.name"
          description="A descriptive name for your testing env."
          placeholder="My local dev env" 
          v-model="env.name">
          Name
        </text-input>
      </div>
      <div class="column">
        <switch-input 
          description="Creates client credentials for the env."
          v-model="env.generate_client" 
          classes="is-large is-success is-rounded">
          Generate Client
        </switch-input>
      </div>
    </div>
  </form>

  <template #footer>
    <submit-button @submit="createEnv" class="is-rounded" left-icon="save">
      Save
    </submit-button>
  </template>
</modal>  
</template>
<script>
export default {
  data: () => ({
    env: {
      name: '',
      generate_client: false
    }
  }),

  methods: {
    createEnv() {
      this.$store.dispatch('app/createTestEnv', this.env).then(() => {
        this.$toast.success('Env Created')
        this.$close(true)
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>